import { useDataManagement } from '../ferramentas/RequisitarAPI.ts';
import { useEffect, useState } from "react";
import style from "./LogoApe.module.css";
import { ReactComponent as CircuitLoader } from '../../img/loaders/circuit-board.svg';

const LogoApe = () => {
    const { customization } = useDataManagement();
    const [logo, setLogo] = useState('/img/logo2.svg');
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    
    useEffect(() => {
        const fetchCustomization = async () => {
            const response = await customization.logo_secondary();
            if (response.ok && response.data?.logo) {
                setLogo(response.data.logo);
            }
        };
        fetchCustomization();
    }, [customization]);

    return (
        <div className={style.logo}>
            {!isImageLoaded && <CircuitLoader />}
            {logo && (
                <img className={style.img_logo}
                    src={logo} 
                    alt="logo"
                    width="100"
                    onLoad={() => setIsImageLoaded(true)}
                    onClick={() => window.open("https://apesolutiontech.com/", "_blank")}
                />
            )}
        </div>
    );
};

export default LogoApe;
